import React, { Component } from 'react';
// import arrow from '../Img/arrow.svg'

export default class TopNav extends Component {

	state={
		backTapped:false, 
		forwardTapped:false,
		serial:"",
	}
	
	componentDidMount(){
		const uid = this.props.userId;
		
        let serial = "";

		if(uid === undefined || uid === "") {
			const chars = "0123456789";
			for(let i=0;i<5;i++){
				serial += chars.charAt(Math.floor(chars.length * Math.random()));
			}			
		} else {
			serial = uid.substr(uid.length - 5);
		}

        this.setState({serial:serial});
	}
	
	
	render() {
		const { style, currentPos, steps, hideStepNumbers, hideSerialNumber } = this.props;
		const isDone= (currentPos >= steps.length - 1);

		const showSteps = !hideStepNumbers && currentPos > 0 && !isDone;

		let label = "";
		if(showSteps){
			label = (steps.length-2)  + " / " + currentPos;
		} else if( !hideSerialNumber && ( currentPos === 0 || isDone ) ) {
			label = [<span key={'a1'}>מס. סידורי ― </span>,<span key={'a2'} style={{direction: "ltr"}}>{this.state.serial}</span>]

		}
		
		return <div style={{ ...style,
			position:"absolute",
			zIndex:0,	
			left: 0,		
			height:58,
		}}>			
			
			<div style={{
				position: "absolute",
				width: "100%",
				height: 20,
				top: 18,
				textAlign: "center",
				fontSize: 16,
				// color: global.colorTheme.grey,
				opacity: 0.5,
				pointerEvents: "none",				
				// backgroundColor:"rgba(0,255,255,0.3)",

			}}>{label}</div>
			
	  	</div>
	}
}




// WEBPACK FOOTER //
// ./src/Comp/Shared/TopNav.js